import React from 'react'

function AboutUs() {
  return (
    <div>
        <h1>Developed for EPICS by team pedagogy</h1>
    </div>
  )
}

export default AboutUs